import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class ConsumerPunchCardHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

  	getPunchCardsByBusinessId(params){	
	  	this.url = this.globals.dataUrl + 'consumerPunchCard/businessId/' + params.businessId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getPunchCardSequencesByPunchCardId(punchCardId, cb){	
	  	this.url = this.globals.dataUrl + 'consumerPunchCard/punchCardId/' + punchCardId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getSequencesByPunchCardId(punchCardId, cb){	
	  	this.url = this.globals.dataUrl + 'consumerPunchCard/sequences/punchCard/' + punchCardId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}  	

	createPunchCard(params, cb){
	    this.url = this.globals.dataUrl + 'consumerPunchCard';

	    console.log(params);
	    console.log(params);

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response.Data);
		    });  
		})           
	}

	udpatePunchCard(id, params, cb){
	    this.url = this.globals.dataUrl + 'consumerPunchCard/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response.Data);
		    }); 
		});             
	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-punch-card-handler.ts